import { Haptics } from "@/services/Haptics"

export const triggerHaptic = (pattern?: any) => {
    if (typeof window === "undefined") return
    Haptics.trigger(pattern)
}
